// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import Notify from 'vue2-notify'

import BootstrapVue from 'bootstrap-vue'
import '@/assets/scss/main.scss'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
import VueFilter from 'vue-filter'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
import Vue2Filters from 'vue2-filters'
import ContentPage from '@/components/ContentPage'
import Content from '@/components/Content'
import Multiselect from 'vue-select'
import CoolLabel from '@/components/CoolLabel'
import IconButton from '@/components/IconButton'

import VueHighcharts from 'vue-highcharts'
import Highcharts from 'highcharts'
import loadMap from 'highcharts/modules/map'
loadMap(Highcharts)

import ToggleButton from 'vue-js-toggle-button'
import VueAffix from 'vue-affix'
import vueSmoothScroll from 'vue-smooth-scroll'

Vue.config.productionTip = false

Vue.use(Notify, { position: 'bottom-right' })
Vue.use(BootstrapVue)
Vue.use(VueFilter)
Vue.use(Vue2Filters)
Vue.use(VueHighcharts, { Highcharts })
Vue.use(ToggleButton)
Vue.use(VueAffix)
Vue.use(vueSmoothScroll)

Vue.component('icon', Icon)
Vue.component('content-page', ContentPage)
Vue.component('multiselect', Multiselect)
Vue.component('cool-label', CoolLabel)
Vue.component('icon-button', IconButton)

/* eslint-disable no-new */
export let vm = new Vue({
  el: '#app',
  router,
  components: { App, Icon, ContentPage, Content, CoolLabel },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js